import script from "./Lesson.vue?vue&type=script&setup=true&lang=js"
export * from "./Lesson.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./Lesson.vue?vue&type=style&index=1&id=58dc732f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58dc732f"]])

export default __exports__